import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
// tslint:disable-next-line: no-implicit-dependencies
import { Observable } from 'rxjs';

import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(
        private readonly authenticationService: AuthenticationService,
        @Inject(PLATFORM_ID) private readonly platformId: Object
        ) {}
    
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add authorization header with jwt token if available
        const currentUser = this.authenticationService.currentUserValue;
        
        // tslint:disable-next-line: no-console        
        if (currentUser && currentUser.token){
            if (isPlatformBrowser(this.platformId)) {
               // tslint:disable-next-line: no-parameter-reassignment
                request = request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${currentUser.token}`
                        // Authorization: `Bearer ${currentUser.token.accessToken}`
                        // Authorization: `Bearer ${currentUser.data.token.accessToken}`
                    }
                });
            }
            if (isPlatformServer(this.platformId)) {
                // Server only code.
            }
            
            
        }
        
        
        

        return next.handle(request);
       
    }
}